import $ from 'jquery';

/* On mobile view, search criteria and search result visibility is controlled by Bootstrap Collapse.
functionality is mainly assigned with data-attributes and visibility classes
*/

function handleSearchViewChanges(container) {

  function onShowResults() {
    container.removeClass('criteria-expanded');
    $('.footer').show();
    $('.giosg_chat_now, .giosg-chat-button').show();
  }

  const criteriaButton = container.find('#search-criteria-toggle');
  const criteriaTab = container.find('#search-criteria');
  const resultTab = container.find('#search-results');

  /* If search criteria is closed, show search results.
    (by default this would not happen if criteria is closed from the toggle button).
  */
  criteriaButton.on('click', function () {
    //if search-criteria is currently visible (and will be hidden)
    document.getElementsByTagName('body')[0].classList.remove('no-scroll-on-mobile');
    document.getElementsByTagName('header')[0].classList.remove('no-show-on-mobile');
    const openResults = $(this).attr('aria-expanded') === 'true';
    if(openResults) {
      $('#search-results').collapse('show');
    }
  });

  //when search criteria is opened, hide footer and chat button
  criteriaTab.on('show.bs.collapse', function () {
    container.addClass('criteria-expanded');
    $('.footer').hide();
    document.getElementsByTagName('body')[0].classList.add('no-scroll-on-mobile');
    document.getElementsByTagName('header')[0].classList.add('no-show-on-mobile');
    $('.giosg_chat_now, .giosg-chat-button').hide();
  });
  
  //when results are opened, scroll to top and show footer and chat button
  resultTab.on('show.bs.collapse', onShowResults); /*function () {
                                                     $(document).scrollTop( container.offset().top );
                                                     container.removeClass('criteria-expanded');
                                                     $('.footer').show();
                                                     $('.giosg_chat_now, .giosg-chat-button').show();
                                                     });*/

  const closeButtons = document.getElementsByClassName('search-criteria__close-mobile');
  if (closeButtons) {
    for (const closeButton of closeButtons) {
      closeButton.addEventListener('click', (e) => {
        document.getElementsByTagName('body')[0].classList.remove('no-scroll-on-mobile');
        document.getElementsByTagName('header')[0].classList.remove('no-show-on-mobile');
      });
    }
  }

  const mql = window.matchMedia('(min-width: 1024px)');

  mql.onchange = (e) => {
    if (e.matches) {
      onShowResults();
      updateSortPlaceholder(false);
    } else {
      updateSortPlaceholder(true);
    }
  }
  if (mql.matches) {
    onShowResults();
    updateSortPlaceholder(false);
  } else {
    updateSortPlaceholder(true);
  } 
}

// update placeholder text in sorting select
function updateSortPlaceholder(isMobile) {
  const placeholder = document.getElementById('multiselect-sort');
  if (placeholder) {
    if (isMobile) {
      placeholder.getElementsByTagName('span')[0].innerHTML = 'Järjestä';
    } else {
      placeholder.getElementsByTagName('span')[0].innerHTML = 'Ei valintaa';
    }
  }
}

function init () {
  if($(".product-finder").length) {
    handleSearchViewChanges($(".product-finder"));
  }
}

export default { init };
export { init };
